module.exports = __webpack_public_path__ + "img/s2.d76497b8.jpg";